import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import type { PwaNotificationSettings } from "../types/pwaNotifications";

type NotificationFormProps = {
  values: PwaNotificationSettings;
  onChange: (key: keyof PwaNotificationSettings, value: boolean) => void;
  disabled?: boolean;
};

const NotificationForm = ({ values, onChange, disabled = false }: NotificationFormProps) => {
  return (
    <Stack spacing={1.5}>
      <Typography variant="body2" color="text.secondary">
        Choose which events trigger push notifications for the installed PWA.
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={values.streamOnline}
            onChange={(_, checked) => {
              onChange("streamOnline", checked);
            }}
            name="streamOnline"
            disabled={disabled}
          />
        }
        label="Stream goes online"
      />
      <FormControlLabel
        control={
          <Switch
            checked={values.streamOffline}
            onChange={(_, checked) => {
              onChange("streamOffline", checked);
            }}
            name="streamOffline"
            disabled={disabled}
          />
        }
        label="Stream goes offline"
      />
    </Stack>
  );
};

export default NotificationForm;
